import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

function opsPath(clientViewId, suffix, params) {
  return `/views/${clientViewId}/midpoint-media/${suffix}${buildClientQuery(params || {})}`;
}

export function fetchMidpointMediaHealth(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/health"));
}

export function fetchMidpointMediaHealthHistory(clientViewId, range = "24h") {
  return clientPortalRequest(opsPath(clientViewId, "ops/health/history", { range }));
}

export function fetchMidpointMediaDigitalOcean(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/digitalocean"));
}

export function fetchMidpointMediaOpenProject(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "ops/openproject"));
}

export function fetchMidpointMediaCrmSummary(clientViewId) {
  return clientPortalRequest(opsPath(clientViewId, "crm/summary"));
}

export function fetchMidpointMediaCrmLeads(clientViewId, params = {}) {
  return clientPortalRequest(opsPath(clientViewId, "crm/leads", params));
}

export function fetchMidpointMediaCrmLead(clientViewId, leadId) {
  return clientPortalRequest(opsPath(clientViewId, `crm/leads/${leadId}`));
}

export function patchMidpointMediaCrmLead(clientViewId, leadId, payload) {
  return clientPortalRequest(opsPath(clientViewId, `crm/leads/${leadId}`), {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}
